
/* ===== index.html inline @line 31 ===== */

 var mapKeys = {
     google: "",
     yandex: ""
 };
 var mosaicDesignId = 17986713;
 var mosaicDesignPrefix = 'i2ald6ztw-1755846912';
 var mosaicTimeZone = 'Europe/Moscow';


/* ===== index.html inline @line 47 ===== */

WebFont.load({
	google: {
		families: [
			"JetBrains Mono:300,400,500",
			"Inter Tight:400,500",
			"&display=swap"
		]}
	});
